
export class FeatureNames {
  static EventTracking: string = "eventtracking";
  static AgeGate: string = "agegate";
}

export class Features {
  static FeatureIsActive = (featureName: string): boolean => {
    const htmlElement = document.querySelector('html');
    const features = htmlElement?.getAttribute('data-features');

    const isActive = features
      ?.toLowerCase()
      .split(' ')
      .includes(featureName.toLowerCase()) ?? false;
    return isActive;
  };

}